import React, { useState, useEffect } from 'react';
import Layout from "../../../../core/Layout";
import SubmitProof from "./submitProof"

import { makeStyles } from '@material-ui/core/styles';
import { Container, 
         Paper, 
         Typography, 
         Box, 
         Button 
       }from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
    margin: theme.spacing(1),
    width: theme.spacing(50),
    height: theme.spacing(50),
    }
},
cardSpace:{marginTop: "250px", margin: "auto"}
}));

const BankDirect = () =>{
    const classes = useStyles();
    const [steps, setSteps] = useState(0);

    
    useEffect(()=>{
        console.log(steps)
    },[])
    return(
        <Layout>
            {
                steps === 0 ? 
                (   
                    <Container>
                        <Box className={classes.root}>
                        <Box className={classes.cardSpace} id="elementId">
                            <Typography variant="h3"> Instruction Page </Typography>
                            <Paper elevation={3}>
                                <Typography> Acount Name</Typography>
                                <Typography> Sparkle-Internatioal-Corporation </Typography>
                                <Typography> Account Number</Typography>
                                <Typography> xxxx-xxxx-xxxx </Typography>
                                <Button
                                    variant="contained" 
                                    color="secondary"
                                    onClick={() => setSteps(1)}
                                    >
                                    Proceed
                                </Button>
                            </Paper>
                        </Box>
                        </Box>
                    </Container>
                ):(
                    <SubmitProof />
                )

           
            }
        </Layout>
    )
}

export default BankDirect;